import type { ReactElement } from 'react'
import { observer } from 'mobx-react-lite'
import { TemplatePickerBase } from 'app/components/templates/TemplatePickerBase'
import type { NoteTemplate } from 'app/generated/graphql'
import { renderSample } from 'app/lib/messageTemplates'
import { NOTE_TEMPLATE_LIST_PARAMS } from 'app/stores/NoteTemplateStore'
import { useNoteTemplateStore } from 'app/stores/StoreContext'
import { bg } from 'lib/background'

type NoteTemplatePickerProps = {
  trigger: ReactElement
  onSelect: (template: NoteTemplate) => void
  side?: `top` | `bottom`
}

export const NoteTemplatePicker = observer(function NoteTemplatePicker({
  trigger,
  onSelect,
  side,
}: NoteTemplatePickerProps) {
  const store = useNoteTemplateStore()
  const templates = store.hits
  const items = templates.map((t) => ({
    id: t.id,
    name: t.name ?? ``,
    // Markdown markers are noise on a two-line preview.
    preview: renderSample(t.body ?? ``)
      .replace(/^#+\s*/gm, ``)
      .replace(/\*\*/g, ``),
    searchText: t.body ?? ``,
  }))

  return (
    <TemplatePickerBase
      trigger={trigger}
      items={items}
      onOpen={() => bg(store.fetchList(NOTE_TEMPLATE_LIST_PARAMS))}
      onSelectId={(id) => {
        const template = templates.find((t) => t.id === id)
        if (template) onSelect(template)
      }}
      manageHref="/settings/templates/notes"
      emptyLabel="No note templates yet."
      side={side}
    />
  )
})
